const item=[
    {
        id:1 ,
        img: 'image/application/android.svg',
        book:'https://drive.google.com/file/d/1MpNZ8WQ13-SCMT4zD3gsQ3qJugxe1j-9/view?usp=sharing',
    },

    {
        id:2 ,
        img: 'image/application/flutter.png',
        book:'https://drive.google.com/file/d/1vdan8B9E9QB78-yax0bLxCmRNCHOD6me/view?usp=sharing',
    },

    {
        id: 3 ,
        img: 'image/application/swift.svg',
        book:'https://drive.google.com/file/d/10AJ8ggQ-_Utuzr8Z6dupVhPS9sG2OttR/view?usp=sharing',
    }
]

export default item